/**
 * IndustryPickerGate — early-return states for IndustryMappingPanel.
 * Covers: initial bootstrap loading AND the no-industry-selected picker.
 */
import React from 'react';
import { Building2 } from 'lucide-react';
import { useT } from '../../i18n/I18nContext.jsx';

export function IndustryPickerGate({ bootstrapLoading, selectedIndustry, industryList, onSelect }) {
  const t = useT();

  if (bootstrapLoading && !selectedIndustry) {
    return (
      <div data-testid="industry-mapping-panel-loading"
        style={{ padding: 40, textAlign: 'center', color: '#94a3b8' }}>
        {t('erp.industryMatrix.loadingIndustries', 'Loading industries…')}
      </div>
    );
  }

  if (!selectedIndustry) {
    return (
      <div data-testid="industry-mapping-panel" style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        <div style={{
          display: 'flex', alignItems: 'center', gap: 10,
          padding: '10px 14px', borderRadius: 6,
          background: 'var(--erp-grid-row-hover, #eff6ff)',
          border: '1px solid var(--erp-border, #bfdbfe)',
          fontSize: 12, color: '#1e40af', lineHeight: 1.55
        }}>
          <Building2 size={14} />
          <div>
            <strong>{t('erp.industryMatrix.title', 'Industry × Module Matrix')}</strong>
            {' — '}{t('erp.industryMatrix.pickHint',
              'pick an industry below to load and edit its module/sub-module/screen scopes.'
            )}
          </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '24px 14px' }}>
          <Building2 size={18} color="#64748b" />
          <label htmlFor="industry-matrix-industry-select"
            style={{ fontSize: 12, fontWeight: 700, color: 'var(--text-primary, #1e293b)' }}>
            {t('erp.industryMatrix.industryLabel', 'Industry')}:
          </label>
          <select
            id="industry-matrix-industry-select"
            data-testid="industry-matrix-industry-select"
            className="form-input"
            value={selectedIndustry}
            onChange={e => onSelect(e.target.value)}
            style={{ minWidth: 280 }}
          >
            <option value="">
              {t('erp.industryMatrix.selectPlaceholder', '— Select an industry to load matrix —')}
            </option>
            {industryList.map(i => (
              <option key={i.IndustryCode} value={i.IndustryCode}>
                {i.IndustryName} ({i.IndustryCode})
              </option>
            ))}
          </select>
          <span style={{ fontSize: 12, color: '#64748b' }}>
            ({industryList.length} {t('erp.industryMatrix.availableIndustries', 'active industries available')})
          </span>
        </div>
      </div>
    );
  }

  return null; // parent continues to full-matrix render
}
